interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
}

export default function EmptyState({ icon = "ri-inbox-line", title, description, actionText, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100">
        <i className={`${icon} text-3xl text-secondary-500`} />
      </div>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>}
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionText}
        </button>
      )}
    </div>
  );
}